import { render, staticRenderFns } from "./addInfo.vue?vue&type=template&id=e507d06c&scoped=true&"
import script from "./addInfo.vue?vue&type=script&lang=js&"
export * from "./addInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e507d06c",
  null
  
)

export default component.exports